
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const iconDefaultProps = {
  spinning: false,
};

export const iconPropTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  spinning: PropTypes.bool,
};

/**
 * The `SvgIcon` component allows you to use your own SVG graphics to create icons.
 * It can be used if the desired icon is not included in the standard icon set.
 */
const SvgIcon = ({
  children,
  g,
  className,
  viewBox = '0 0 24 24',
  title,
  idGenerator,
  ...other
}) => {
  const componentClassName = classNames('ee_svg-icon', className);

  // Render SVG content: either children or <g> with inner HTML
  const drawing = g ? <g dangerouslySetInnerHTML={{ __html: g }} /> : children;

  // Generate unique title ID for accessibility
  const titleId = idGenerator ? `title-${idGenerator.next()}` : undefined;

  return (
    <svg
      {...other}
      className={componentClassName}
      focusable="false"
      viewBox={viewBox}
      aria-hidden={title ? 'false' : 'true'}
      role="img"
      aria-labelledby={title ? titleId : undefined}
    >
      {title && <title id={titleId}>{title}</title>}
      {drawing}
    </svg>
  );
};

SvgIcon.defaultProps = {
  viewBox: '0 0 24 24',
  title: undefined,
  g: undefined,
  idGenerator: undefined,
};

SvgIcon.propTypes = {
  title: PropTypes.string,
  viewBox: PropTypes.string,
  g: PropTypes.string,
  idGenerator: PropTypes.any,
};

export default SvgIcon;
